import { BinIcon } from "../../../../../components/icon/Icon";
import { ProfileButtonEmailTitleStyled } from "./styled/ProfileButtonEmailStyled";
import React, { useCallback } from "react";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { getUserEmailConfirmedSelector, getUserEmailSelector } from "../../../../../app/appSelectors";
import classNames from "classnames";
import { useLangContext } from "../../../../../providers/LangProvider/LangProviderContext.js";

function ProfileButtonEmailTitle(props) {
    const {
        isShowEmailConfirmedMessage,
        setIsShowEmailConfirmedMessage,
        userEmail,
        userEmailConfirmed,
    } = props;
    const {getLangPath} = useLangContext();

    const handleEmailClick = useCallback(() => {
        if (!isShowEmailConfirmedMessage && userEmailConfirmed) {
            setIsShowEmailConfirmedMessage(true);
            setTimeout(() => {
                setIsShowEmailConfirmedMessage(false);
            }, 2000);
        }
    }, [isShowEmailConfirmedMessage, setIsShowEmailConfirmedMessage, userEmailConfirmed]);

    return <ProfileButtonEmailTitleStyled
        className={classNames('ps-1 d-flex align-items-center')}
        onClick={handleEmailClick}
    >
        {isShowEmailConfirmedMessage
            ? <BinIcon name="IcInfoCircle"/>
            : <BinIcon name="IcEnvelope" style={{fill: 'var(--color-secondary-active)', fontSize: '16px'}}/>
        }
        <span className={classNames('ms-2', {'color-white': isShowEmailConfirmedMessage})}>
            {isShowEmailConfirmedMessage ? getLangPath('sign_up.email_confirmed') : userEmail}
        </span>
    </ProfileButtonEmailTitleStyled>
}

const mapStateToProps = createStructuredSelector({
    userEmail: getUserEmailSelector,
    userEmailConfirmed: getUserEmailConfirmedSelector,
})

export default connect(mapStateToProps)(ProfileButtonEmailTitle);
